var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShortcut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fcfcfc",
    width: "100px",
    height: "100px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#fcfcfc",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,13.934976 L20.4264545,9.5 L12,5.06502396 L3.57354553,9.5 L12,13.934976 Z M2.26712678,9.05754089 L11.7671268,4.05754089 C11.912897,3.9808197 12.087103,3.9808197 12.2328732,4.05754089 L21.7328732,9.05754089 C22.0890423,9.24499828 22.0890423,9.75500172 21.7328732,9.94245911 L12.2328732,14.9424591 C12.087103,15.0191803 11.912897,15.0191803 11.7671268,14.9424591 L2.26712678,9.94245911 C1.91095774,9.75500172 1.91095774,9.24499828 2.26712678,9.05754089 Z M12,16.934976 L21.2671268,12.0575409 C21.5114902,11.9289286 21.8138468,12.0227634 21.9424591,12.2671268 C22.0710714,12.5114902 21.9772366,12.8138468 21.7328732,12.9424591 L12.2328732,17.9424591 C12.087103,18.0191803 11.912897,18.0191803 11.7671268,17.9424591 L2.26712678,12.9424591 C2.02276336,12.8138468 1.92892856,12.5114902 2.05754089,12.2671268 C2.18615321,12.0227634 2.4885098,11.9289286 2.73287322,12.0575409 L12,16.934976 Z M12,19.934976 L21.2671268,15.0575409 C21.5114902,14.9289286 21.8138468,15.0227634 21.9424591,15.2671268 C22.0710714,15.5114902 21.9772366,15.8138468 21.7328732,15.9424591 L12.2328732,20.9424591 C12.087103,21.0191803 11.912897,21.0191803 11.7671268,20.9424591 L2.26712678,15.9424591 C2.02276336,15.8138468 1.92892856,15.5114902 2.05754089,15.2671268 C2.18615321,15.0227634 2.4885098,14.9289286 2.73287322,15.0575409 L12,19.934976 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortcut);
export default __webpack_public_path__ + "static/media/shortcut.00e3c6b7581f1b333157951e408fb117.svg";
export { ForwardRef as ReactComponent };